import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowDownUp, Trash2 } from "lucide-react";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
  onGaranti: (data: any) => void;
  columnName: (data: any) => void;
}

const GuaranteeCoulmn = ({
  onClickDelete,
  onGaranti,
  columnName,
}: ColumnsProps) => {
  const GuaranteeCoulmn = useMemo(
    () => [
      {
        header: "سال زراعی",
        accessorKey: "crop_year_name",
      },
      {
        header: "کشاورز ضامن",
        accessorKey: "guarantor_farmer_name",
        enableColumnFilter: false,
      },
      {
        header: "کشاورز ضمانت شده",
        accessorKey: "guaranteed_farmer_name",
        enableColumnFilter: false,
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("guarantee_price")}
          >
            <span> مبلغ ضمانت</span>
            <span className="text-blue-600 text-[10px]">(ریال)</span>

            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),

        accessorKey: "guarantee_price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },

      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <button
              className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                onGaranti(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-green-800 text-white">
                رفع ضمانت
              </span>
            </button>
            <button
              className="flex mx-3 items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                onClickDelete(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-red-800 text-white">
                حذف
              </span>
            </button>
          </div>
        ),
      },
    ],
    []
  );

  return GuaranteeCoulmn;
};

export default GuaranteeCoulmn;
